import dayjs from 'dayjs'
const empDateValid = (rule, value, callback) => {
    // 从业资格有效期校验
    const empDate = dayjs(value).valueOf() // 获取的截止时间戳
    const curTime = dayjs().startOf('D').valueOf() // 获取的当前时间
    if (empDate < curTime) {
        callback(new Error('从业资格证到期日期不能小于当前日期'))
    } else {
        callback()
    }
}
export default {
    driverName: [{ required: true, message: '请输入司机姓名', trigger: ['blur', 'change'] }],
    sex: [{ required: true, message: '请选择性别', trigger: ['blur', 'change'] }],
    driveType: [{ required: true, message: '请输入准驾车型', trigger: ['blur', 'change'] }],
    // countryCode: [{ required: true, message: '请选择国家', trigger: ['blur', 'change'] }],
    // provinceCode: [{ required: true, message: '请选择省份', trigger: ['blur', 'change'] }],
    // cityCode: [{ required: true, message: '请选择城市', trigger: ['blur', 'change'] }],
    // familyAddress: [{ required: true, message: '请输入详细地址', trigger: ['blur', 'change'] }],
    idCardFileName: [{ required: true, message: '请上传身份证件', trigger: ['blur', 'change'] }],
    idCardBottomSideFileName: [{ required: true, message: '请上传身份证件背面', trigger: ['blur', 'change'] }],
    idCardStartDate: [{ required: true, message: '请选择身份证件有效期', trigger: ['change'] }],
    idCardStartTime: [{ required: true, message: '请选择身份证件有效期', trigger: ['change'] }],
    drivingLicenceFileName: [{ required: true, message: '请上传驾驶证', trigger: ['blur', 'change'] }],
    driveStartDate: [{ required: true, message: '请选择驾驶证件有效期', trigger: ['change'] }],
    dateIssue: [{ required: true, message: '请选择驾驶证初次领证日期', trigger: ['change'] }],
    driverLicenseAuthority: [{ required: true, message: '请输入驾驶证签发机关', trigger: ['blur', 'change'] }],
    empCertificate: [{ required: false, message: '请输入从业资格证号', trigger: ['blur', 'change'] }],
    empCertificateFileName: [{ required: false, message: '请上传从业资格证', trigger: ['blur', 'change'] }],
    empCertificateEndDate: [{ required: false, message: '请选择从业资格证到期日期', trigger: ['blur', 'change'] },
    { validator: empDateValid, trigger: ['blur','change'] },],
    delegateStartTime: [{ required: false, message: '请选择委派开始时间', trigger: ['blur', 'change'] }],
    delegateEndTime: [{ required: false, message: '请选择委派结束时间', trigger: ['blur', 'change'] }],
    // 委派函
    delegateFileName: [{ required: false, message: '请选择委派函', trigger: ['change'] }],
    // 签署人
    stamperCode: [{ required: false, message: '请选择签署人', trigger: ['change'] }],
    // 签署人手机号码
    stamperMobile: [{ required: false, message: '请输入签署人手机号码', trigger: ['change'] }],
    // 签署方式
    pushType: [{ required: false, message: '请选择签署方式', trigger: ['change'] }],
};